









































































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class Parts extends Vue {
  @Prop({ type: String, required: true })
  public fill!: string;

  @Prop({ type: String, default: 'black' })
  public fillAlternative!: string;
}
